/**
 * Get the API base URL based on current environment
 * @returns {string} The API base URL
 */
export const getApiBaseUrl = () => {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    return "http://localhost:5000";
  }

  // For production environment
  if (window.location.hostname === "stylebuzzpro.com") {
    // Use HTTPS with /api path that nginx proxies to backend
    return "https://stylebuzzpro.com/api";
  }

  // For other environments, use HTTPS with /api path
  return `https://${window.location.hostname}/api`;
};

/**
 * Get the full URL for an uploaded image
 * @param {string} imagePath - The relative path of the image
 * @returns {string} The full URL for the image
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // Get base URL without /api suffix for production
  const baseUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
      ? "http://localhost:5000"
      : `https://${window.location.hostname}`;

  // If the path already includes uploads, use it as is
  const path = imagePath.includes("uploads/")
    ? imagePath
    : `uploads/${imagePath}`;

  // For production, ensure we use the /api prefix
  return window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
    ? `${baseUrl}/${path}`
    : `${baseUrl}/api/${path}`;
};

/**
 * Get the store logo URL or fallback to default
 * @param {Object} store - The store object
 * @param {string} fallbackUrl - The fallback image URL (default: "assets/img/store/store-01.png")
 * @returns {Object} Object with isUploaded flag and url
 */
export const getStoreLogoUrl = (
  store,
  fallbackUrl = "assets/img/store/store-01.png"
) => {
  if (store?.logo) {
    return {
      isUploaded: true,
      url: getImageUrl(store.logo),
    };
  }
  return {
    isUploaded: false,
    url: fallbackUrl,
  };
};
